import { useEffect,useState } from 'react';

const useAlterarCaracteristicasBotoes = (editar) => {
    const [caracteristicasBotaoSubmit, setCaracteristicasBotaoSubmit] = useState({
        label: 'Incluir',
        icon: 'pi pi-plus',
        disabled: true,
        className: 'p-button-success p-col-12 p-md-6 p-lg-3',
    });
    const [caracteristicasBotaoLimpar, setCaracteristicasBotaoLimpar] = useState({
        label: 'Limpar',
        icon: 'pi pi-minus-circle',
        disabled: false,
        className: 'p-button-primary p-col-12 p-md-6 p-lg-3',
    });
    useEffect(() => {
        if (editar) {
            setCaracteristicasBotaoSubmit({
                label: 'Confirmar Edição',
                icon: 'pi pi-pencil',
                disabled: false,
                className: 'p-button-warning',
            });
            setCaracteristicasBotaoLimpar({
                label: 'Cancelar Edição',
                icon: 'pi pi-ban',
                disabled: false,
                className: 'p-button-danger',
            });
        } else {
            setCaracteristicasBotaoLimpar({
                label: 'Limpar',
                icon: 'pi pi-minus-circle',
                disabled: false,
                className: 'p-button-primary botao-acao',
            });
            setCaracteristicasBotaoSubmit({
                label: 'Incluir',
                icon: 'pi pi-plus',
                disabled: true,
                className: 'p-button-success ',
            });
        }
    }, [editar]);
    return {
        caracteristicasBotaoSubmit,
        caracteristicasBotaoLimpar
    }
};

export default useAlterarCaracteristicasBotoes;
